import { useProfileByIdQuery } from "@/features/profile/api/selectProfile";
import type { EducationViewT } from "@/types/database/events";

interface Props {
	education: EducationViewT;
}

const EducationSummary = ({ education }: Props) => {
	if (!education) return null;

	const { data: educatorProfile } = useProfileByIdQuery(education.educated_by);

	return (
		<div className="space-y-2">
			<div className="flex flex-col gap-1">
				<h4 className="font-medium">{education.education_name}</h4>
				{educatorProfile && (
					<p className="text-muted-foreground text-sm">
						Educated by {educatorProfile.name}
					</p>
				)}
			</div>
			{education.education_description && (
				<p className="text-muted-foreground text-sm">
					{education.education_description}
				</p>
			)}
		</div>
	);
};

export default EducationSummary;
